/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_TitleInputs */

const en_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const de_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettres de motivation`)
};

const es_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación`)
};

const it_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione`)
};

const nl_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrieven`)
};

const pl_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne`)
};

const fi_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjeet`)
};

const da_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve`)
};

const sv_cover_letters_title = /** @type {(inputs: Cover_Letters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personliga brev`)
};

/**
* | output |
* | --- |
* | "Cover Letters" |
*
* @param {Cover_Letters_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_title = /** @type {((inputs?: Cover_Letters_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_title(inputs)
	if (locale === "fr") return fr_cover_letters_title(inputs)
	if (locale === "es") return es_cover_letters_title(inputs)
	if (locale === "it") return it_cover_letters_title(inputs)
	if (locale === "nl") return nl_cover_letters_title(inputs)
	if (locale === "pl") return pl_cover_letters_title(inputs)
	if (locale === "fi") return fi_cover_letters_title(inputs)
	if (locale === "da") return da_cover_letters_title(inputs)
	if (locale === "sv") return sv_cover_letters_title(inputs)
	return en_cover_letters_title(inputs)
});